import { render, staticRenderFns } from "./AiringCard.vue?vue&type=template&id=59b37204&scoped=true"
import script from "./AiringCard.vue?vue&type=script&lang=js"
export * from "./AiringCard.vue?vue&type=script&lang=js"
import style0 from "./AiringCard.vue?vue&type=style&index=0&id=59b37204&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b37204",
  null
  
)

export default component.exports